/* Pinnacle Garage USA - phone list view: tapping a product photo opens a swipeable photo preview
   (all of that product's photos) instead of leaving the page. "View Product" goes to the product page.
   Also: the "First Time Buyer?" tab's square shows a thumbnail of the car photo the popup will open with next,
   and product breadcrumbs keep only the 2 most recent products: Home / Products / last 2 products / this product.
   Also: "In Stock" / "Sold Out" text on product cards gets green / red classes, and the product page's benefit rows
   get a shipping-box icon and sentence-case supporting text.
   Also: cart - "Finance with Shop Pay" heading moves above Estimated Total (its paragraph stays put); product page -
   "Order today" becomes a label like the benefit rows; quick order list rows are sorted by wheel size. */
(function () {
  var cache = {};
  function isPhoneList() { return window.innerWidth < 750 && document.body.classList.contains('pg-view--list'); }
  function handleFrom(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  function fetchImgs(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      var imgs = (p.media && p.media.length ? p.media.filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src; }) : p.images) || [];
      cache[h] = { t: p.title, imgs: imgs, url: p.url || ('/products/' + h) }; return cache[h];
    });
  }
  function sized(src, w) { if (!src) return src; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function open(d, startSrc) {
    var o = document.createElement('div'); o.className = 'pgg'; o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-label', 'Product photos');
    var slides = d.imgs.map(function (s, i) { return '<div class="pgg__slide"><img src="' + sized(s, 1100) + '" alt="' + (d.t || '').replace(/"/g, '&quot;') + ' photo ' + (i + 1) + '"' + (i > 1 ? ' loading="lazy"' : '') + '></div>'; }).join('');
    var dots = d.imgs.length > 1 ? d.imgs.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') : '';
    o.innerHTML = '<div class="pgg__top"><div class="pgg__t"></div><button type="button" class="pgg__x" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="pgg__track">' + slides + '</div>' +
      '<div class="pgg__bot"><div class="pgg__dots">' + dots + '</div><div class="pgg__n">1 / ' + d.imgs.length + '</div><a class="pgg__go" href="' + d.url + '">View Product</a></div>';
    o.querySelector('.pgg__t').textContent = d.t || '';
    document.body.appendChild(o);
    var prevOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
    var track = o.querySelector('.pgg__track'), dotEls = o.querySelectorAll('.pgg__dots i'), n = o.querySelector('.pgg__n');
    var cur = 0;
    function sync() { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i === cur) return; cur = i; dotEls.forEach(function (e, k) { e.classList.toggle('on', k === i); }); n.textContent = (i + 1) + ' / ' + d.imgs.length; }
    track.addEventListener('scroll', function () { clearTimeout(track.__t); track.__t = setTimeout(sync, 60); }, { passive: true });
    function close() { o.classList.remove('is-in'); document.documentElement.style.overflow = prevOverflow; setTimeout(function () { o.remove(); }, 200); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', key);
    o.querySelector('.pgg__x').addEventListener('click', close);
    setTimeout(function () { o.classList.add('is-in'); }, 10);
  }
  document.addEventListener('click', function (e) {
    if (!isPhoneList()) return;
    /* the card's title link stretches over the whole card, so decide by where the tap landed */
    var li = e.target.closest && e.target.closest('#product-grid > .grid__item, .template-search__results .grid__item'); if (!li) return;
    if (e.target.closest('button, .pgx-actions, form, select, input')) return;
    var media = li.querySelector('.card__inner'); if (!media) return;
    var rb = media.getBoundingClientRect();
    if (e.clientX < rb.left || e.clientX > rb.right || e.clientY < rb.top || e.clientY > rb.bottom) return; var a = li && li.querySelector('a[href*="/products/"]'); var h = a && handleFrom(a); if (!h) return;
    e.preventDefault(); e.stopPropagation();
    var img = media.querySelector('img');
    fetchImgs(h).then(function (d) { if (!d.imgs.length) { location.href = d.url; return; } open(d, img && (img.currentSrc || img.src)); }).catch(function () { location.href = a.getAttribute('href'); });
  }, true);
})();

/* "First Time Buyer?" tab preview - follows the popup's own rotation (localStorage pgNlCar, list in #pgnl-cars) */
(function () {
  function run() {
    var tab = document.getElementById('pgnl-tab'), sq = tab && tab.querySelector('b'), list = document.getElementById('pgnl-cars');
    if (!sq || !list) return;
    var cars = []; try { cars = JSON.parse(list.textContent) || []; } catch (e) {}
    if (!cars.length) return;
    function paint() {
      var i = 0; try { i = parseInt(localStorage.getItem('pgNlCar'), 10); } catch (e) {}
      if (isNaN(i) || i < 0) i = 0;
      var c = cars[i % cars.length], u = String(c.u || '').replace(/([?&])width=\d+/, '$1width=160');
      sq.classList.add('pgnl-tab__pic'); sq.setAttribute('aria-hidden', 'true');
      sq.style.setProperty('background-image', "url('" + u + "')", 'important'); sq.style.setProperty('background-position', c.p || '50% 50%', 'important');
    }
    paint();
    new MutationObserver(function () { setTimeout(paint, 0); }).observe(tab, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Breadcrumbs: Home / Products / (up to 2 previously viewed products) / current page */
(function () {
  function run() {
    var nav = document.querySelector('[data-pg-bc]'); if (!nav || !/\/products\//.test(location.pathname)) return;
    var list = nav.querySelector('ol, ul'); if (!list) return;
    var lis = [].slice.call(list.children), cur = list.querySelector('[data-pg-bc-cur]');
    var isProd = function (li) { var a = li.querySelector('a'); return !!a && /\/products\//.test(a.getAttribute('href') || ''); };
    /* keep Home, the first non-product crumb (Products / collection), the last 2 products and the current page */
    var curHref = location.pathname.split('?')[0];
    lis.slice(1).forEach(function (li) { var a = li.querySelector('a'); if (li !== cur && (/404|not found/i.test(li.textContent) || (a && a.getAttribute('href').split('?')[0] === curHref))) li.remove(); });
    lis = [].slice.call(list.children);
    var mid = lis.slice(1).filter(function (li) { return li !== cur; });
    var firstCat = mid.filter(function (li) { return !isProd(li); })[0];
    var keep = mid.filter(isProd).slice(-2);
    mid.forEach(function (li) { if (li !== firstCat && keep.indexOf(li) < 0) li.remove(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* "In Stock" green / "Sold Out" red on product cards (anywhere on the page, including grids loaded later) */
(function () {
  var RX = /^(in stock|sold out)$/i, t = null;
  function mark(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT), n, hits = [];
    while ((n = w.nextNode())) { var s = n.textContent.trim(); if (s && s.length < 12 && RX.test(s)) hits.push(n); }
    hits.forEach(function (n) {
      var e = n.parentElement; if (!e || e.closest('button, .badge, .facets-wrapper, .facets, .mobile-facets, label, .pgnl, option, select')) return;
      if (!e.closest('.grid__item, .card, .card-wrapper, [class*="card"], [class*="pgx-meta"]')) return;
      var out = /sold/i.test(n.textContent);
      e.classList.toggle('pg-stk-out', out); e.classList.toggle('pg-stk-in', !out);
    });
  }
  function run() {
    mark();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { mark(); }, 250); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Product page benefit rows: shipping-box icon instead of the briefcase, sentence-case supporting text */
(function () {
  var BOX = '<path d="M21 7.5 12 3 3 7.5v9L12 21l9-4.5v-9Z"/><path d="M3 7.5 12 12l9-4.5"/><path d="M12 12v9"/><path d="M7.5 5.25 16.5 9.75"/>';
  function fix() {
    document.querySelectorAll('.pg-assure__list > li').forEach(function (li) {
      if (li.__pgFix) return; li.__pgFix = 1;
      var txt = li.textContent;
      var svg = li.querySelector('svg');
      if (svg && /Ships in/i.test(txt)) svg.innerHTML = BOX;
      var span = li.querySelector('span'); if (!span) return;
      [].slice.call(span.childNodes).forEach(function (n) {
        if (n.nodeType !== 3) return;
        n.textContent = n.textContent.replace(/On All US Orders/i, 'On all US orders​'); /* zero-width space keeps the site-wide Title Case script from re-capitalising it */
      });
    });
  }
  function run() { fix(); new MutationObserver(fix).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Cart: "Finance with Shop Pay" heading above Estimated Total (the cart footer re-renders on every change, so keep re-applying) */
(function () {
  function place() {
    document.querySelectorAll('.cart__footer .js-contents').forEach(function (box) {
      var head = box.querySelector('.pg-cart-shoppay-terms__head'), tot = box.querySelector('.totals');
      if (!head || !tot || head.nextElementSibling === tot) return;
      head.classList.add('pg-fin-top'); box.insertBefore(head, tot);
    });
  }
  function run() { place(); new MutationObserver(place).observe(document.body, { childList: true, subtree: true }); }
  if (/^\/cart/.test(location.pathname)) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); }
})();

/* Product page: "Order today" as an uppercase label, the rest as supporting text */
(function () {
  function fix() {
    document.querySelectorAll('.pg-assure__eta > span').forEach(function (sp) {
      if (sp.querySelector('.pg-eta-k')) return;
      var n = sp.firstChild; if (!n || n.nodeType !== 3) return;
      var m = n.textContent.match(/^(\s*)(Order today)(.*)$/i); if (!m) return;
      var b = document.createElement('b'); b.className = 'pg-eta-k'; b.textContent = m[2];
      n.textContent = m[3]; sp.insertBefore(b, n); if (m[1]) sp.insertBefore(document.createTextNode(m[1]), b);
    });
  }
  function run() { fix(); new MutationObserver(fix).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Quick order list: rows sorted by wheel size - diameter, width, offset, then bolt pattern and center bore */
(function () {
  function key(tr) {
    var t = ((tr.querySelector('.variant-item__name') || tr).textContent || '').toUpperCase();
    var m = t.match(/(\d{2})X([\d.]+)"?\s*([+-]\d+)?/) || [], b = t.match(/\((\d)X([\d.]+)/) || [], c = t.match(/CB:?\s*([\d.]+)/) || [];
    return [parseFloat(m[1]) || 99, parseFloat(m[2]) || 99, parseFloat(m[3]) || 0, parseFloat(b[1]) || 9, parseFloat(b[2]) || 999, parseFloat(c[1]) || 999, t];
  }
  function cmp(a, b) { for (var i = 0; i < a.length; i++) { if (a[i] < b[i]) return -1; if (a[i] > b[i]) return 1; } return 0; }
  function sort() {
    document.querySelectorAll('quick-order-list tbody').forEach(function (tb) {
      var rows = [].slice.call(tb.children).filter(function (r) { return r.classList.contains('variant-item'); });
      if (rows.length < 2) return;
      var keyed = rows.map(function (r) { return { r: r, k: key(r) }; }).sort(function (x, y) { return cmp(x.k, y.k); });
      if (keyed.every(function (x, i) { return x.r === rows[i]; })) return;
      /* each size row is followed by its own (hidden) error row - move them as a pair */
      var marker = document.createComment('pg'); tb.insertBefore(marker, rows[0]);
      keyed.forEach(function (x) { var err = x.r.nextElementSibling; var pair = err && err.classList.contains('desktop-row-error') ? err : null; tb.insertBefore(x.r, marker); if (pair) tb.insertBefore(pair, marker); });
      marker.remove();
    });
  }
  var t = null;
  function run() { sort(); new MutationObserver(function () { clearTimeout(t); t = setTimeout(sort, 80); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Wheels page cards: availability sits under the price ("In Stock" / "Sold Out", like the collection cards)
   instead of a "Sold Out" badge on the photo. Fit badges on the photo (when a vehicle is chosen) stay. */
(function () {
  var t = null;
  function fix() {
    document.querySelectorAll('a.pgwp-card').forEach(function (a) {
      var price = a.querySelector('.pgwp-price'); if (!price) return;
      var out = !!a.querySelector('.pgwp-b--out'), s = a.querySelector('.pgwp-stk');
      if (s && s.getAttribute('data-out') === String(out)) return;
      if (!s) { s = document.createElement('div'); price.parentNode.insertBefore(s, price.nextSibling); }
      s.className = 'pgwp-stk ' + (out ? 'pg-stk-out' : 'pg-stk-in'); s.setAttribute('data-out', String(out));
      s.textContent = out ? 'Sold Out' : 'In Stock';
    });
  }
  function run() { fix(); new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 60); }).observe(document.body, { childList: true, subtree: true }); }
  if (!/\/pages\/wheels/.test(location.pathname) && !document.querySelector('.pgwp')) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();